import useAuthenticatedFetch from "./useAuthenticatedFetch";

export const usePost = () => {
    const authenticatedFetch = useAuthenticatedFetch();

    function post(endpoint, formData, handleError) {
        return authenticatedFetch(endpoint, {
            method: "POST",
            body: formData
        })
            .then((response) => {
                if (!response.ok) handleError(response.statusText);
                return response;
            }).catch((error) => {
                handleError(error.message);
            });
    }

    return post;
}

export default usePost;